(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kezvion-buy-now"] && !Shopify.designMode) return;
  try {
    (() => {
    const findLink = (target) => (target instanceof Element ? target.closest('[data-kz-buy-now]') : null);

    const canBuy = (link) => !link.closest('form')?.querySelector('.add-to-cart-button')?.disabled;

    const parseMap = (link) => {
      try {
        return JSON.parse(link.getAttribute('data-kz-crf-map') || '{}');
      } catch {
        return {};
      }
    };

    const selectedLine = (link) => {
      const form = link.closest('form');
      const variantId = form?.querySelector('[name="id"]')?.value;
      if (!variantId) return null;
      const quantity = Math.max(
        1,
        parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1
      );
      return { id: String(variantId), quantity };
    };

    const checkoutUrl = (link, kezionVariantId, quantity) => {
      const map = parseMap(link);
      const crfId = map[kezionVariantId];
      if (!crfId) return null;
      const host = (link.dataset.kzCrfHost || 'https://5sykat-1t.myshopify.com').replace(/\/$/, '');
      return `${host}/cart/${encodeURIComponent(crfId)}:${quantity}?checkout`;
    };

    const syncHref = (link) => {
      const line = selectedLine(link);
      if (!line) return;
      const url = checkoutUrl(link, line.id, line.quantity);
      if (url) link.setAttribute('href', url);
    };

    document.addEventListener('change', (event) => {
      const t = event.target;
      if (!(t instanceof Element)) return;
      const form = t.closest('form');
      if (!form) return;
      form.querySelectorAll('[data-kz-buy-now]').forEach(syncHref);
    });

    document.addEventListener('click', (event) => {
      const link = findLink(event.target);
      if (!link) return;

      event.preventDefault();
      if (!canBuy(link) || link.classList.contains('is-loading')) return;

      const line = selectedLine(link);
      if (!line) {
        window.alert('Please select a variant.');
        return;
      }

      const url = checkoutUrl(link, line.id, line.quantity);
      if (!url) {
        window.alert('Checkout link is not ready for this variant. Please contact support.');
        return;
      }

      link.classList.add('is-loading');
      window.location.assign(url);
    });

    document.querySelectorAll('[data-kz-buy-now]').forEach(syncHref);
  })();
  } catch(e) { console.error(e); }
})();

})();
